import type { IBranding } from '../_Types/Branding.types';
import { SonarBatchImport } from './BatchImport';
import { SonarFallBack } from './FallBack';
import { SonarGroups } from './Groups';
import { SonarModalLogout } from './ModalLogout';
import { SonarOnboard } from './Onboard/OnboardBranding';
import { SonarThemes } from './SonarThemes';
import { SonarThemeDefault } from './Themes/Sonarprint/SonarThemeDefault';

const SonarBranding: IBranding = {
  BrandingName: 'Sonarprint',
  Onboard: SonarOnboard,
  FallBack: SonarFallBack,
  ModalLogout: SonarModalLogout,
  Groups: SonarGroups,
  BatchImport: SonarBatchImport,

  Theme: {
    themes: SonarThemes,
    defaultLightTheme: 'sonar-light',
    defaultDarkTheme: 'sonar-light',
    defaultCSSConfig: SonarThemeDefault(),
    enableSystemTheme: true,
    enablePersistence: true,
    injectCSSVariables: true,
    storageKey: 'sonarprint-theme',
  },
};

export { SonarBranding };
